import Dropdown from "../../components/ui/dropdowns/Dropdown";
import useFormPage1 from "./useFormPage1";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import useGroupMemberships from "../../hooks/useGroupMemberships";

const FormPage1 = ({ state, dispatch, ACTIONS, auditCoords }) => {
  const groupMemberships = useGroupMemberships();
  const {
    auditCrewSelectHandler,
    auditContractorSelectHandler,
    auditMarketSelectHandler,
    convertMarketHandler,
    convertAreanameHandler,
    auditLCPSelectHandler,
    convertContractorsHandler,
    convertCrewHandler,
    convertInHouseSplicersHandler,
    auditInHouseSplicerSelectHandler,
  } = useFormPage1({ dispatch, ACTIONS });

  return (
    <>
      <SectionHeader text="Location" />
      <Dropdown
        identifier="auditMarket"
        title="Market"
        url={`${process.env.REACT_APP_API_URL}/audit/market`}
        fetchingMessage="Fetching Markets..."
        noOptionsMessage="No Markets found for your location."
        value={state.selectedMarket}
        selectHandler={auditMarketSelectHandler}
        convertOptionsHandler={convertMarketHandler}
        bodyObject={auditCoords}
      />
      <Dropdown
        identifier="auditLCP"
        title="LCP/Ring/Areaname"
        url={`${process.env.REACT_APP_API_URL}/audit/areanames`}
        fetchingMessage="Fetching LCP/Ring/Areaname..."
        noOptionsMessage="No LCPs/Rings/Areanames found for your location."
        value={state.selectedLCP}
        selectHandler={auditLCPSelectHandler}
        convertOptionsHandler={convertAreanameHandler}
        bodyObject={auditCoords}
      />
      <SectionHeader
        text={groupMemberships.seeINHS ? "Crew or In-House Splicer" : ""}
      />
      <SectionHeader text="Crew" />
      <Dropdown
        identifier="contractor"
        title="Contractor"
        url={`${process.env.REACT_APP_API_URL}/data/contractors`}
        fetchingMessage="Fetching Contractors..."
        noOptionsMessage="No contractors found."
        value={state.selectedContractor}
        selectHandler={auditContractorSelectHandler}
        convertOptionsHandler={convertContractorsHandler}
      />
      {state.selectedContractor.value && (
        <Dropdown
          identifier="auditCrew"
          title="Crew"
          url={`${process.env.REACT_APP_API_URL}/data/enabledContractorCrews`}
          fetchingMessage="Fetching Crews..."
          noOptionsMessage="No crews found."
          value={state.selectedCrew}
          selectHandler={auditCrewSelectHandler}
          convertOptionsHandler={convertCrewHandler}
          bodyObject={{
            contractorMCANumber: state.selectedContractor.value.MCA_NUMBER,
          }}
          dependencies={[state.selectedContractor]}
        />
      )}
      {groupMemberships.seeINHS && (
        <>
          <SectionHeader text="In-House Splicer" />
          <Dropdown
            identifier="inHouseSplicer"
            title="In-House Splicer"
            url={`${process.env.REACT_APP_API_URL}/ad/inHouseSplicers`}
            fetchingMessage="Fetching In-House Splicers..."
            noOptionsMessage="No in-house splicers found."
            value={state.selectedInHouseSplicer}
            selectHandler={auditInHouseSplicerSelectHandler}
            convertOptionsHandler={convertInHouseSplicersHandler}
          />
        </>
      )}
    </>
  );
};

export default FormPage1;
